import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { HiArrowRight } from 'react-icons/hi2';
import {
  Section,
  Container,
  Header,
  Title,
  Subtitle,
  Steps,
  Step,
  StepNumber,
  StepTitle,
  StepDescription,
  Arrow,
} from './HowItWorks.styled';

const stepKeys = ['step1', 'step2', 'step3'] as const;

export default function HowItWorks() {
  const { t } = useTranslation();

  return (
    <Section id="jak-to-dziala">
      <Container>
        <Header>
          <Title>{t('howItWorks.title')}</Title>
          <Subtitle>{t('howItWorks.subtitle')}</Subtitle>
        </Header>
        <Steps>
          {stepKeys.map((key, index) => (
            <Fragment key={key}>
              <Step>
                <StepNumber>{index + 1}</StepNumber>
                <StepTitle>{t(`howItWorks.${key}.title`)}</StepTitle>
                <StepDescription>{t(`howItWorks.${key}.description`)}</StepDescription>
              </Step>
              {index < stepKeys.length - 1 && (
                <Arrow>
                  <HiArrowRight size={24} />
                </Arrow>
              )}
            </Fragment>
          ))}
        </Steps>
      </Container>
    </Section>
  );
}
